<div class="p-4 flex justify-center">
  <img
    src="/logo-meumaisodonto.png"
    alt="Meu Mais Odonto Logo"
    class="max-w-[127px] h-auto w-full"
  />
</div>
